import api from 'api/apiInstance';

export function clientCaseFinancialPlanningHealthChecksPrintApi(path: string) {
  return {
    path,
    GET: () => api.get(path),
  };
}
